export default "__VITE_ASSET__47980f64__"